import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos/caso-self-care-is-for-everyone-crecimiento-shopify")({
  beforeLoad: () => {
    throw redirect({ to: "/es/recursos/caso-self-care-is-for-everyone-crecimiento", statusCode: 301 });
  },
});
